import { Chip } from '~/components/granular/chip/Chip';
import type { ChipProps } from '~/components/granular/chip/Chip.types';
import { Icon } from '~/components/granular/icon/Icon';
import type { IconType } from '~/components/icons';
import { useFormatMessage } from '~/intl';
import type { RegistryTransactionRecognitionStatus } from '~/schemas/registry-transactions';

type ReconciliationPillStatusProps = {
  status: RegistryTransactionRecognitionStatus | null | undefined;
  className?: string;
  size?: ChipProps['size'];
};

const STATUS_ICONS: Record<RegistryTransactionRecognitionStatus, IconType> = {
  RECOGNISED: 'CheckboxCircleFillIcon',
  PARTIALLY_RECOGNISED: 'PartlyRecognisedIcon',
  UNRECOGNISED: 'ListCircleIcon',
};

const DEFAULT_ICON_SIZE = 14;
const X_SMALL_ICON_SIZE = 12;

export function ReconciliationPillStatus({ status, className, size = 'small' }: ReconciliationPillStatusProps) {
  const formatMessage = useFormatMessage();

  const resolvedStatus = status ?? 'UNRECOGNISED';

  const label = formatMessage({ id: `enum.transactionStatus.${resolvedStatus}` });

  const appearance = resolvedStatus === 'UNRECOGNISED' ? 'ghost' : 'teal';

  const iconSize = size === 'x-small' ? X_SMALL_ICON_SIZE : DEFAULT_ICON_SIZE;
  const iconClass = size === 'x-small' ? 'h-3 w-3 shrink-0' : 'h-3.5 w-3.5 shrink-0';

  return (
    <Chip
      appearance={appearance}
      className={`inline-flex items-center gap-1 ${className ?? ''}`}
      size={size}
      title={label}
    >
      <Icon aria-hidden className={iconClass} height={iconSize} icon={STATUS_ICONS[resolvedStatus]} width={iconSize} />
      <span className="truncate">{label}</span>
    </Chip>
  );
}
